import { render } from "./QuotePeriodOverview.vue?vue&type=template&id=1dcd49f3"
import script from "./QuotePeriodOverview.vue?vue&type=script&lang=js"
export * from "./QuotePeriodOverview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__